<template>
  <div>
    <div class="">
      <div class="handle-box">
        <el-input
          size="small"
          placeholder="公司名称"
          v-model.trim="companyName"
          class="handle-input mr10"
        ></el-input>
        <el-select size="small" v-model="status" class="mr10">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-table
        :data="data.records"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column
          width="150px"
          align="center"
          label="订单号"
          prop="order_code"
        >
        </el-table-column>
        <el-table-column
          min-width="200"
          prop="company_name"
          align="center"
          label="用户名称"
        ></el-table-column>
        <el-table-column
          min-width="180"
          align="center"
          prop="name"
          label="申请年度证书"
        >
          <template #default="scope">
            <el-button type="text" @click="preview(scope.row)"
              >{{ scope.row.year }}年度证书预览</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="申请时间" min-width="240" align="center">
          <template #default="scope">
            <ul>
              <li>
                申请时间：
                {{
                  $utils.formatDate(
                    scope.row.create_time,
                    "yyyy-MM-dd hh:mm:ss"
                  )
                }}
              </li>
              <li>
                颁发时间：
                {{
                  $utils.formatDate(scope.row.audit_time, "yyyy-MM-dd hh:mm:ss")
                }}
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column min-width="100px" align="center" label="被举报次数">
          <template #default="scope">
            <el-link
              type="danger"
              :underline="false"
              href="javascript:void(0);"
              @click="getReport(scope.row)"
              >被举报：{{ scope.row.reportCount }}次</el-link
            >
          </template>
        </el-table-column>
        <el-table-column
          min-width="150px"
          align="center"
          label="已使用团体数量"
        >
          <template #default="scope">
            <el-link
              type="success"
              :underline="false"
              href="javascript:void(0);"
              @click="getGroup(scope.row)"
              >团体颁发：{{ scope.row.groupIntegrityCount }}个</el-link
            >
          </template>
        </el-table-column>
        <el-table-column min-width="100px" align="center" label="操作">
          <template #default="scope">
            <el-button
              type="text"
              @click="revoke(scope.row)"
              v-if="scope.row.status === 2"
              >撤销证书</el-button
            >
            <el-link
              type="info"
              :underline="false"
              href="javascript:void(0);"
              v-if="scope.row.status === 4"
              >已撤销</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="操作人" width="120" align="center">
          <template #default="scope">{{
            scope.row.audit_realname || "-"
          }}</template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="data.current"
          :page-size="20"
          :total="data.total"
          @current-change="getData"
        ></el-pagination>
      </div>
      <!-- 预览证书 -->
      <el-dialog v-model="preview_dialog" width="900px">
        <div class="preview-dialog">
          <img :src="preview_url" alt="" />
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="danger" size="mini" @click="preview_dialog = false"
              >关闭</el-button
            >
          </span>
        </template>
      </el-dialog>
      <!-- 举报列表 -->
      <el-dialog v-model="report_dialog" width="80%">
        <div class="report_dialog-dialog">
          <el-table
            :data="reportData.records"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
          >
            <el-table-column width="90px" align="center" label="用户类型">
              <template #default="scope"
                ><span>{{
                  userType(scope.row.whistle_blower_type)
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              label="举报者"
              align="center"
              prop="whistle_blower_name"
            ></el-table-column>
            <el-table-column align="center" width="170px" label="举报时间">
              <template #default="scope">
                {{
                  $utils.formatDate(
                    scope.row.create_time,
                    "yyyy-MM-dd hh:mm:ss"
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              prop="report_notes"
              label="举报说明"
              header-align="center"
            ></el-table-column>
            <el-table-column align="center" width="90" label="举报资料">
              <template #default="scope">
                <span v-if="scope.row.report_info">
                  <el-button
                    type="text"
                    @click="
                      $utils.download(
                        scope.row.report_info,
                        scope.row.report_file_name
                      )
                    "
                    >下载</el-button
                  >
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <!-- <Page @page="getReportPage" :total="reportData.total"></Page> -->
            <el-pagination
              background
              layout="total, prev, pager, next"
              :current-page="reportData.current"
              :page-size="20"
              :total="reportData.total"
              @current-change="getReportPage"
            ></el-pagination>
          </div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="danger" size="mini" @click="report_dialog = false"
              >关闭</el-button
            >
          </span>
        </template>
      </el-dialog>
      <!-- 团体列表 -->
      <el-dialog v-model="group_dialog" width="700px">
        <div class="report_dialog-dialog">
          <el-table
            :data="groupData.records"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
          >
            <el-table-column align="center" label="团体名称" prop="name">
            </el-table-column>
            <el-table-column align="center" label="证书状态">
              <template #default="scope">
                <el-link
                  type="danger"
                  :underline="false"
                  href="javascript:void(0);"
                  v-if="scope.row.status === 0"
                  >无效</el-link
                >
                <el-link
                  type="success"
                  :underline="false"
                  href="javascript:void(0);"
                  v-if="scope.row.status === 1"
                  >有效</el-link
                >
              </template>
            </el-table-column>
            <el-table-column align="center" width="170px" label="颁发时间">
              <template #default="scope">
                {{
                  $utils.formatDate(scope.row.awardDate, "yyyy-MM-dd hh:mm:ss")
                }}
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              layout="total, prev, pager, next"
              :current-page="groupData.current"
              :page-size="20"
              :total="groupData.total"
              @current-change="getGroupPage"
            ></el-pagination>
          </div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="danger" size="mini" @click="group_dialog = false"
              >关闭</el-button
            >
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      companyName: "",
      status: "",
      options: [
        {
          value: -1,
          label: "全部",
        },
        {
          value: 4,
          label: "已撤销",
        },
      ],
      group_dialog: false,
      report_dialog: false,
      reportData: {},
      preview_dialog: false,
      preview_url: "",
      groupData: {},

      itemData: {},
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      if (this.companyName.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          status: this.status,
          companyName: this.companyName,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.sincerity.issued.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    userType(type) {
      switch (type) {
        case 1:
          return "个人";
        case 2:
          return "企业";
        case 3:
          return "团体";
      }
    },
    preview(data) {
      this.preview_url = this.$utils.fileUrl(data.file_url);
      this.preview_dialog = true;
    },
    async getReport(data) {
      this.itemData = data;
      await this.getReportPage();
      this.report_dialog = true;
    },
    // 获取举报数据
    async getReportPage(page = 1) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            id: this.itemData.id,
            currentPage: page,
            pageSize: 20,
          };
          const res = await this.$api.sincerity.publicity.reportList(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.reportData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    async getGroup(data) {
      this.itemData = data;
      await this.getGroupPage();
      this.group_dialog = true;
    },
    // 获取团体数据
    async getGroupPage(page = 1) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            companyId: this.itemData.company_id,
            year: this.itemData.year,
            currentPage: page,
            pageSize: 20,
          };
          const res = await this.$api.sincerity.issued.groupList(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.groupData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    revoke(data) {
      this.$confirm(
        `撤销证书后，当前公司将不能再申请${data.year}（年度）的诚信认证，请谨慎操作!`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.submitRevoke(data);
        })
        .catch(() => {});
    },
    async submitRevoke(data) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            companyId: data.company_id,
            year: data.year,
            id: data.id,
          };
          const res = await this.$api.sincerity.issued.revoke(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData(this.data.current);
            this.$message.success("证书已撤销");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
  },
  watch: {
    status: {
      handler(val, ovl) {
        this.getData();
      },
    },
    companyName: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;
}

.preview-dialog {
  img {
    width: 100%;
  }
}
</style>